/* Grandezas de exibição compartilhadas pelos capítulos do painel de preço.
 * Só formatação e geometria: nenhuma conta de negócio nasce aqui. */

import { formatarMoeda, formatarNumero, formatarPercentualPontos } from '@/design/formato';

/** "+ R$ 7.447,37" / "− R$ 120,00": delta em dinheiro, com sinal explícito. */
export function sinalMoeda(v: number | null | undefined): string {
  if (v === null || v === undefined || !Number.isFinite(v)) return '';
  return (v < 0 ? '− ' : '+ ') + formatarMoeda(Math.abs(v));
}

/** "+ 17,1 p.p.": delta entre dois percentuais que vêm em FRAÇÃO do motor. */
export function sinalPontos(v: number | null | undefined): string {
  if (v === null || v === undefined || !Number.isFinite(v)) return '';
  return (
    (v < 0 ? '− ' : '+ ') + formatarPercentualPontos(Math.abs(v) * 100).replace('%', '') + ' p.p.'
  );
}

/**
 * "+ 2,0" / "− 1,9": delta de quantidade, sempre com UMA casa decimal.
 *
 * A casa forçada não é capricho: sem ela, uma diferença de 1,99 sai como "2"
 * e passa por número inteiro exato ao lado de duas colunas que mostram 3,3 e
 * 1,4. Com a casa, o leitor vê que os três números estão na mesma precisão.
 */
export function sinalQuantidade(v: number): string {
  return (v < 0 ? '− ' : '+ ') + formatarNumero(Math.abs(v), { casasMin: 1, casasMax: 1 });
}

/** Quantidade solta em pt-BR, para texto corrido ("5,4", "1.250"). */
export function quantia(v: number | null | undefined, casas = 1): string {
  return formatarNumero(v, { casasMax: casas });
}

/** Posição de um valor numa régua, presa entre 0 e 1. Geometria, não juízo. */
export function escala(valor: number | null | undefined, minimo: number, maximo: number): number {
  if (valor === null || valor === undefined || !Number.isFinite(valor)) return 0;
  if (maximo <= minimo) return 0;
  return Math.min(1, Math.max(0, (valor - minimo) / (maximo - minimo)));
}
